module.exports = __webpack_public_path__ + "static/media/zero-people.537d7b6e.jpg";